//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import React from 'react';
import { Box } from '@mui/material';

interface PanelIconProps {
  icon: React.ReactNode;
}

/**
 * A panel's icon, wherever it is drawn.
 *
 * Hidden from assistive technology because it always sits beside the title it
 * stands for, and an exposed icon would have that name read twice.  MUI's own
 * icons hide themselves; a client may pass anything, so the wrapper is what
 * makes that true of every icon rather than most of them.
 *
 * Transparent to the pointer for the same reason it is decorative: in a title
 * bar it sits in the middle of the drag surface, whose allowlist admits that
 * surface and the title and nothing else, so an icon that took the press
 * would be a dead patch to grab the panel by.
 */
const PanelIcon = ({ icon }: PanelIconProps) => (
  <Box
    component="span"
    aria-hidden
    sx={{ display: 'flex', alignItems: 'center', pointerEvents: 'none' }}
  >
    {icon}
  </Box>
);

export default PanelIcon;
